export type SortingInfo = {
  sortBy: string;
  sortDirection: SortDirection;
};

export enum SortDirection {
  ASCENDING = 'Ascending',
  DESCENDING = 'Descending'
}
